import React from 'react';
import { Element } from './LoginButton.styles';
import Text from '@/components/typography/Text/Text';
import { ACCOUNT_LINK } from '@/helpers/browser';
import Link from '@/providers/Link';
import { useTranslations } from 'next-intl';

const LoginButton = () => {
  const t = useTranslations('Pacote');
  return (
    <Element>
      <Text>
        {t('Solicite um')} <Link href="/viagens/crie-seu-roteiro">{t('orçamento personalizado')}</Link>{' '}
        {t('ou acesse a')} <Link href={ACCOUNT_LINK.login}>{t('Área do Agente')}</Link>.
      </Text>
      <Text>
        {t('Caso não tenha cadastro')},{' '}
        <a href={ACCOUNT_LINK.signup} target="_blank">
          {t('clique aqui')}
        </a>{' '}
        {t('para fazer seu cadastro')}.
      </Text>
    </Element>
  );
};

export default LoginButton;
